// @flow

import React from 'react';

import {
  Avatar,
  Container,
  Item,
  ChipActions,
  Card,
  CardHeader,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Badge,
  IconButton,
  Button,
  Input,
  AuthButton,
} from 'components';

import AddCircleIcon from 'material-ui-icons/AddCircle';

import withAuth from 'hoc/withAuth';
import { withStyles, createStyleSheet } from 'material-ui/styles';

import kebabCase from 'lodash/kebabCase';

import ToolCard from '../../Tool/components/ToolCard';

const propTypes = {};

const defaultProps = {};

const styleSheet = createStyleSheet('StackView', theme => ({
  flexGrow: { flex: '1 1 auto' },
  profileCardActions: {
    flexWrap: 'wrap',
  },
  button: {
    width: '100%',
  },
  buttonIcon: {
    paddingRight: theme.spacing.unit,
  },
  input: {
    width: '100%',
  },
  toolCardContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: '8px 8px 0 0',
  },
}));

class StackView extends React.Component {
  state = {
    featureValue: null,
    featureId: null,
    showFeatureInput: false,
  };

  handleFeatureButtonClick = () => this.setState({ showFeatureInput: true });

  handleFeatureInputChange = event => {
    this.setState({ featureValue: event.target.value });
  };

  handleFeatureFormSubmit = async event => {
    event.preventDefault();

    const result = await this.props.addFeature({
      variables: {
        label: this.state.featureValue,
        slug: kebabCase(this.state.featureValue),
      },
    });

    const { data } = result;

    await this.props.addFeatureOnStack({
      variables: {
        stacksStackId: this.props.stackData.Stack.id,
        featuresFeatureId: data.createFeature.id,
      },
    });

    this.setState({ featureValue: '' });
  };

  render() {
    const { stackData: { Stack = {} }, classes } = this.props;

    const {
      // slug,
      name,
      detail,
      description,
      image,
      url,
      features,
      categories,
      tools,
      // user,
    } = Stack;

    return (
      <Container justify="center">
        <Item sm={12} md={8} lg={8} style={{ padding: '0 8px' }}>
          <Card>
            <CardHeader title="Profile" />
            <CardHeader
              avatar={<Avatar src={image && image.url} />}
              title={
                <a href={url} target="_blank" rel="noopener noreferrer">
                  {name}
                </a>
              }
              subheader={description}
            />
            <ChipActions items={categories} />
            <CardContent>
              <Typography type="caption">
                {detail}
              </Typography>
            </CardContent>
          </Card>
        </Item>

        <Item sm={12} md={8} lg={8} style={{ padding: '0 8px' }}>
          <form onSubmit={this.handleFeatureFormSubmit}>
            <Card>
              <CardHeader title="Features" />
              <List>
                {features &&
                  features.map(({ id, label, count }) =>
                    <ListItem key={id} button>
                      <ListItemText primary={label} />
                      <ListItemSecondaryAction>
                        <IconButton>
                          <Badge badgeContent={count} accent />
                        </IconButton>
                      </ListItemSecondaryAction>
                    </ListItem>
                  )}
                {this.state.showFeatureInput &&
                  <ListItem>
                    <Input
                      placeholder="기능 작성 후 엔터!"
                      className={classes.input}
                      onChange={this.handleFeatureInputChange}
                      value={this.state.featureValue}
                    />
                  </ListItem>}
              </List>
              {this.props.isLoggedIn
                ? <Button
                    raised
                    color="primary"
                    className={classes.button}
                    type={this.state.showFeatureInput ? 'submit' : 'button'}
                    disabled={
                      this.state.showFeatureInput && !this.state.featureValue
                    }
                    value={this.state.featureValue}
                    onClick={
                      this.state.showFeatureInput
                        ? this.handleFeatureFormSubmit
                        : this.handleFeatureButtonClick
                    }
                  >
                    <AddCircleIcon className={classes.buttonIcon} />
                    {this.state.showFeatureInput
                      ? '클릭 또는 엔터로 기능 추가 하기'
                      : '기능 추가'}
                  </Button>
                : <AuthButton raised className={classes.button} color="primary">
                    <AddCircleIcon className={classes.buttonIcon} />
                    기능 추가 하기(로그인 필요)
                  </AuthButton>}
            </Card>
          </form>
        </Item>
        <Item sm={12} md={8} lg={8} style={{ padding: '0 8px' }}>
          <Card>
            <CardHeader title="Tools" />

            <CardContent className={classes.toolCardContainer}>
              {tools &&
                tools.map(({ id, image, ...restToolData }) =>
                  <Item sm={6} md={4} lg={4}>
                    <ToolCard
                      {...restToolData}
                      key={id}
                      imageUrl={image && image.url}
                      onCardClick={() => {}}
                      style={{ margin: 8 }}
                    />
                  </Item>
                )}
            </CardContent>
          </Card>
        </Item>
      </Container>
    );
  }
}

StackView.propTypes = propTypes;
StackView.defaultProps = defaultProps;

export default withAuth(withStyles(styleSheet)(StackView));



// WEBPACK FOOTER //
// ./src/App/Stack/components/StackView.js